import axios from 'axios';
import { store } from '../app/store';
import { setLoading } from '../redux/loaderSlice';
import { clearUser } from '../redux/userSlice';

const api = axios.create({
  baseURL: 'https://api.example.com', // replace with your API
});

api.interceptors.request.use(
  (config) => {
    store.dispatch(setLoading(true));
    const token = store.getState().user.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    store.dispatch(setLoading(false));
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    store.dispatch(setLoading(false));
    return response;
  },
  (error) => {
    store.dispatch(setLoading(false));
    if (error.response?.status === 401) {
      store.dispatch(clearUser());
    }
    return Promise.reject(error);
  }
);

export const get = (url, config) => api.get(url, config);
export const post = (url, data, config) => api.post(url, data, config);
export const put = (url, data, config) => api.put(url, data, config);
export const del = (url, config) => api.delete(url, config);
export default api;
